import React, { useState } from 'react'
import TicketAppointment from './component/TicketAppointments';
import { Card } from '@/components/ui/Card';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/ToggleGroup';
import { Calendar, ViewIcon } from 'lucide-react';
import { ListIcon } from 'lucide-react';
import TicketTable from '../tickets/component';
import { TicketStatus, useGetAllTaskCountQuery } from '@/services/LiveQueueService';
import { formatDate, getStatusColor } from '@/utils/Helper';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/Tabs';

const  TicketView= () => {

  const {data} =useGetAllTaskCountQuery();
    const [viewMode, setViewMode] = useState<"TicketAppoitment" | "list">(
      "list"
    );
  
  return (
    <div className="w-full p-2">
      <Card className="pt-3">
        <div className="flex justify-start px-4 pb-2">
          <Tabs
            defaultValue="list"
            value={viewMode}
            onValueChange={(value) =>
              setViewMode(value as "TicketAppoitment" | "list")
            }
          >
            <TabsList>
              <TabsTrigger value="list" variant={"primary"}>
                <ListIcon className="h-4 w-4 mr-2" />
                List
              </TabsTrigger>
              <TabsTrigger value="TicketAppoitment" variant={"primary"}>
                <Calendar className="h-4 w-4 mr-2" />
                Calendar
              </TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
        <div className="flex flex-col gap-3 justify-center items-center lg:gap-0 lg:flex-row">
          <div className="bg-white   ">
            <div className="flex flex-col md:flex-row gap-4 items-start md:items-center">
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-11  gap-4 px-2 flex-grow w-full items-center">
                {[
                  {
                    status: "todays_reservations",
                    label: `Today's Appointments (${formatDate(new Date())})`,
                    value: data?.tickets.todays_reservations ?? 0,
                  },
                  {
                    status: "ARCHIVED",
                    label: "Archived",
                    value: data?.tickets.ARCHIVED ?? 0,
                  },
                  {
                    status: "ARRIVED",
                    label: "Arrived",
                    value: data?.tickets.ARRIVED ?? 0,
                  },
                  {
                    status: "AWAITING_INFO",
                    label: "Awaiting Info",
                    value: data?.tickets.AWAITING_INFO ?? 0,
                  },
                  {
                    status: "CANCELLED",
                    label: "Cancelled",
                    value: data?.tickets.CANCELLED ?? 0,
                  },
                  {
                    status: "CHECKED_IN",
                    label: "Serving",
                    value: data?.tickets.CHECKED_IN ?? 0,
                  },
                  {
                    status: "COMPLETED",
                    label: "Completed",
                    value: data?.tickets.COMPLETED ?? 0,
                  },
                  {
                    status: "HOLD",
                    label: "Hold",
                    value: data?.tickets.HOLD ?? 0,
                  },
                  {
                    status: "IN_PROGRESS",
                    label: "In Progress",
                    value: data?.tickets.IN_PROGRESS ?? 0,
                  },
                  {
                    status: "NEW",
                    label: "New",
                    value: data?.tickets.NEW ?? 0,
                  },
                  {
                    status: "RESERVED",
                    label: "Reserved",
                    value: data?.tickets.RESERVED ?? 0,
                  },
                ].map((item) => (
                  <button
                    key={item.status}
                    className={`${getStatusColor(item.status as TicketStatus)} text-white rounded-md p-2 flex flex-col items-center justify-center size-24`}
                  >
                    <div className="text-2xl font-bold">{item.value}</div>
                    <div className="text-xs">{item.label}</div>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {viewMode === "TicketAppoitment" ? (
          <TicketAppointment
            showReservedOnly={true}
            viewMode={viewMode}
            setViewMode={setViewMode}
          />
        ) : (
          <TicketTable />
        )}
      </Card>
    </div>
  );
}

export default TicketView;


